import React from "react";
import { useParams } from "react-router-dom";

const ArtsMonuments = () => {
  const { title } = useParams(); // Get the title from the route

  return (
    <div>
      <h1>{title}</h1>
      <p>Details about {title} will go here.</p>
    </div>
  );
};

export default ArtsMonuments;
